import { OCR_SUPPORTED_FILE_TYPES } from '../models/file.model';
import { IFileDocument } from '../models/interfaces/files.interface';

export class FilesHelper {
  public static isValidForGetPagesAndWords(file: IFileDocument): boolean {
    const fileName = file.name.toLowerCase();
    if (OCR_SUPPORTED_FILE_TYPES.some((ext) => fileName.includes(ext))) {
      return true;
    }
    return false;
  }

  public static isReaderSupported(file: IFileDocument): boolean {
    const { fileType = '' } = file || {};
    return ['image', 'pdf', 'xml', 'html', 'htm'].includes(fileType);
  }

  public static isCanvasSupported(file: IFileDocument): boolean {
    const { fileType = '' } = file || {};
    return ['image', 'pdf'].includes(fileType);
  }

  public static isHtml(file: IFileDocument): boolean {
    const { fileType = '' } = file || {};
    return ['htm', 'html'].includes(fileType);
  }

  public static isXml(file: IFileDocument): boolean {
    const { fileType = '' } = file || {};
    return fileType === 'xml';
  }

  public static normalizeFileType(file: IFileDocument): IFileDocument {
    const { fileExtension = '' } = file || {};
    switch (fileExtension) {
      case 'jpeg':
      case 'png':
      case 'bmp':
      case 'jpg':
      case 'jfif':
        file.fileType = 'image';
        break;
      default:
        file.fileType = file.fileExtension;
        break;
    }

    return file;
  }
}
